import React, {Component} from 'react';
import {connect} from 'react-redux';
import UrlPusher from "../../../Helpers/UrlPusher";
import HTML from "../../../Helpers/HTML";
import ReactResizeDetector from 'react-resize-detector';
import { observer } from "mobx-react";

class Text extends Component {
  render() {
    return (
      <div>
        <ReactResizeDetector refreshMode={"debounce"} refreshRate={500} handleHeight onResize={()=>{ this.props.reScroll(); }}>
          <UrlPusher>
           <HTML>{this.props.item.message}</HTML>
          </UrlPusher>
        </ReactResizeDetector>
      </div>
    )
  }
}

export default observer(Text);